import CheckOutlined from '@ant-design/icons/CheckOutlined'
import CloseOutlined from '@ant-design/icons/CloseOutlined'
import DownloadOutlined from '@ant-design/icons/DownloadOutlined'
import EditOutlined from '@ant-design/icons/EditOutlined'
import FileTextOutlined from '@ant-design/icons/FileTextOutlined'
import InfoCircleTwoTone from '@ant-design/icons/InfoCircleTwoTone'
import LeftOutlined from '@ant-design/icons/LeftOutlined'
import RightOutlined from '@ant-design/icons/RightOutlined'
import SnippetsOutlined from '@ant-design/icons/SnippetsOutlined'
import {
  Button,
  Card,
  Checkbox,
  Empty,
  Modal,
  Space,
  Spin,
  Tabs,
  Tag,
  Tooltip,
  Upload,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import React, { memo, useEffect, useMemo, useState } from 'react'
import { Layer, Stage } from 'react-konva'
import { Document, Page } from 'react-pdf'
import { blue } from '../../color'
import config from '../../config'
import {
  DIGITAL_SIGN_STATUS,
  DIGITAL_TYPE_SIGN_SYSTEM,
  DIGITAL_TYPE_SIGN_USER,
  SIGN_PROVIDER,
  SIGN_VISIBLE,
} from '../../constants'
import utils from '../../utils'
import { trimOverLengthString } from '../Common/CellText'
import ContentBlockWrapper from '../ContentBlockWrapper'
import EmptyContent from '../EmptyContent'
import SpinnerInlineComponent from '../SpinnerInlineComponent/SpinnerInlineComponent'
import {
  DocumentController,
  DocumentWrapper,
  HeaderPopupSign,
  NameDocument,
  PopupSignWrapper,
  SignatureBox,
  SignatureList,
  ThumbnailsWrapper,
} from './PopupSignStyled'
import RectangleBox from './RectangleBox'
import SignModal from './SignModal'
import { getNumberFromArray, SIGN_TYPES, SIGNER_TYPES } from './constant'

const { apiUrl } = config
const { TabPane } = Tabs
const CheckboxGroup = Checkbox.Group
const { Meta } = Card
const { confirm } = Modal

const PopupSign = props => {
  const {
    signedDocumentStore,
    loadingAnimationStore,
    fileStore,
    authenticationStore,
    isVisiblePopupSign,
    handleClosePopupSign,
    hiddenSelectDocument,
    handleAfterSign,
    hiddenFooterOption,
  } = props

  let { fileId } = props

  const { currentUser } = authenticationStore

  const { fileBlob, originFileObj, responseSign } = signedDocumentStore
  const [selectedSignature, setSelectedSignature] = useState(null)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [displaySignChecked, setDisplaySignChecked] = useState(false)
  const [otherCheckboxValues, setOtherCheckboxValues] = useState([])
  const [addFooter, setAddFooter] = useState(true)
  const [rectangles, setRectangles] = useState([])
  const [styleCanvas, setStyleCanvas] = useState({ width: 595, height: 842 })
  const [pdfPageSize, setPdfPageSize] = useState({ width: 595, height: 842 })

  const [idImg, setIdImg] = useState()
  const [numPages, setNumPages] = useState()
  const [pageNumber, setPageNumber] = useState(1)
  const [thumbnails, setThumbnails] = useState([])
  const [loadedPdf, setLoadedPdf] = useState()
  const [signatureList, setSignatureList] = useState([])

  const combinedValues = [
    ...(displaySignChecked ? [SIGNER_TYPES.displaySign] : []),
    ...otherCheckboxValues,
  ]

  const handleFinishSign = () => {
    setSelectedSignature(null)
    setRectangles(null)
    setIdImg(null)
    setPageNumber(1)
    setDisplaySignChecked(false)
    setOtherCheckboxValues([])
    setAddFooter(true)
    handleClosePopupSign()
    signedDocumentStore.clearDataPopupSign()
    setStyleCanvas({ ...styleCanvas, border: null })
  }

  const [visibleSignature, setVisibleSignature] = useState(SIGN_VISIBLE.VISIBLE)

  const options = [
    {
      key: 1,
      label: 'Ẩn chữ ký',
      value: SIGN_VISIBLE.HIDE,
    },
    // {
    //   key: 2,
    //   label: 'Không ảnh', value: 0,
    // },
  ]

  const footerOptions = [
    {
      key: 1,
      label: 'Thêm footer phê duyệt phát hành (chỉ lần ký đầu)',
      value: 'ADD_FOOTER',
    },
  ]

  useEffect(() => {
    if (!currentUser) return
    loadingAnimationStore.setShowSpinInline(true)
    signedDocumentStore
      .getUserSignatureList()
      .then(res => {
        setSignatureList(res.data)
      })
      .finally(() => {
        loadingAnimationStore.setShowSpinInline(false)
      })
  }, [currentUser])

  const scaleFactor = styleCanvas.width / pdfPageSize.width

  const handleSelectSignature = signId => {
    if (!signId) return
    setIdImg(signId)

    const img = document.getElementById(signId)
    const imgWidth = img.naturalWidth
    const imgHeight = img.naturalHeight

    const aspectRatio = imgWidth / imgHeight
    const isLandscape = aspectRatio > 1
    const isPortrait = aspectRatio < 1
    const isSquare = aspectRatio === 1

    console.log(imgWidth, imgHeight)

    let calculatedWidth, calculatedHeight
    if (Math.abs(imgWidth - imgHeight) < 5) {
      calculatedWidth = imgWidth * 0.2291
      calculatedHeight = calculatedWidth
    } else if (isLandscape) {
      calculatedWidth = imgWidth * 0.35
      calculatedHeight = calculatedWidth / aspectRatio
    } else if (isPortrait) {
      calculatedHeight = imgHeight * 0.35
      calculatedWidth = calculatedHeight * aspectRatio
    } else {
      calculatedWidth = imgWidth * 0.5
      calculatedHeight = imgHeight * 0.5
    }

    setRectangles([
      {
        x: 10, // Initial x-position; adjust if needed
        y: 10, // Initial y-position; adjust if needed
        width: calculatedWidth,
        height: calculatedHeight,
        id: 'rect1',
      },
    ])
  }

  const handleSign = async checkboxValues => {
    if (utils.isNullish(selectedSignature))
      return message.error('Bạn phải chọn chữ ký trước khi ký!')
    // if (combinedValues.length === 0)
    //   return message.error('Vui lọc chọn trên bộ ký')

    loadingAnimationStore.showSpinner(true)
    const formData = new FormData()
    formData.append('file', originFileObj)
    // let newTmpfilePdfIdContainImageSignature
    // let filePdfName = originFileObj.name

    const signId = selectedSignature.signId
    const img = document.getElementById(signId)
    const imgWidth = img.naturalWidth
    const imgHeight = img.naturalHeight
    const ratioImg = imgWidth / imgHeight

    // Tính toán tọa độ dựa trên tỷ lệ ảnh, không cần SIGN_TYPE
    const scale = ratioImg // Tùy chỉnh theo loại tỷ lệ nếu cần
    const newWidth = imgWidth * scale
    const newHeight = imgHeight * scale

    const fnLlx = rectangles[0].x * scaleFactor
    const fnLly =
      styleCanvas.height -
      (rectangles[0].y + rectangles[0].height * scaleFactor)
    const fnUrx = fnLlx + rectangles[0].width
    const fnUry = fnLly + rectangles[0].height
    try {
      if (!fileId) {
        const { data } = await fileStore.uploadFile(formData)
        fileId = data.file_id
      }
      // newTmpfilePdfIdContainImageSignature = await PdfEsignUltil.appendSignatureImageToPdfAndUploadToServe(
      //   fileId,
      //   filePdfName,
      //   idImg,
      //   pageNumber,
      //   fnLlx,
      //   fnLly,
      //   fnUrx,
      //   fnUry
      // )
      // fileId = newTmpfilePdfIdContainImageSignature
      let dataSubmit = {
        reason: 'Signed',
        location: 'VietNam',
        contactInfo: '',
        provider: SIGN_PROVIDER.VNPT,
        isVisible: visibleSignature,
        addFooter,
        listSignFile: [
          {
            fileId: fileId,
          },
        ],
      }
      if (idImg) {
        dataSubmit = {
          ...dataSubmit,
          type:
            selectedSignature.type === DIGITAL_TYPE_SIGN_SYSTEM
              ? DIGITAL_TYPE_SIGN_SYSTEM
              : DIGITAL_TYPE_SIGN_USER,
          image: idImg,
          page: pageNumber,
          visibleType:
            selectedSignature?.typeSignature === SIGN_TYPES.CIRCLE_SIGN
              ? getNumberFromArray(checkboxValues)
              : '7',
          llx: fnLlx,
          lly: fnLly,
          urx: fnUrx,
          ury: fnUry,
        }
      } else {
        dataSubmit = {
          ...dataSubmit,
          type: DIGITAL_TYPE_SIGN_SYSTEM,
          image: '',
          page: 1,
          llx: 300,
          lly: 794,
          urx: 590,
          ury: 830,
        }
      }
      const res = await signedDocumentStore.signDocumentSavis(dataSubmit)
      signedDocumentStore.setResponseSign(res)
      if (handleAfterSign) {
        signedDocumentStore.setResponseSign(undefined)
        await handleAfterSign(res.data.listSignFile[0].fileSignId)
      }
      setIsModalVisible(false)
      setSelectedSignature(null)
      message.success('Ký số thành công!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Ký số thất bại!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const showSignConfirm = () => {
    if (
      (selectedSignature &&
        selectedSignature.status === DIGITAL_SIGN_STATUS.APPROVAL) ||
      selectedSignature == null
    ) {
      confirm({
        title: 'Bạn có chắc chắn muốn ký tài liệu này?',
        icon: <InfoCircleTwoTone />,
        content: '',
        okText: 'Đồng ý',
        okType: 'primary',
        cancelText: 'Hủy bỏ',
        onOk() {
          handleSign()
        },
        onCancel() {
          setStyleCanvas({ ...styleCanvas, border: null })
          console.log('Hủy ký')
        },
      })
    } else {
      message.info('Chữ ký này chưa được duyệt')
    }
  }

  const showSignModal = () => {
    if (
      (selectedSignature &&
        selectedSignature.status === DIGITAL_SIGN_STATUS.APPROVAL) ||
      selectedSignature == null
    ) {
      setIsModalVisible(true)
    } else {
      message.info('Chữ ký này chưa được duyệt')
    }
  }

  const renderPage = async (pdf, pageNumber) => {
    const page = await pdf.getPage(pageNumber)
    const viewport = page.getViewport({ scale: 1 })
    setStyleCanvas({
      width: viewport.width,
      height: viewport.height,
      border: '1px solid #000',
    })
    setPdfPageSize({ width: viewport.width, height: viewport.height })
  }

  const onDocumentLoadSuccess = pdf => {
    const { numPages } = pdf
    setNumPages(numPages)
    const thumbnails = []
    for (let i = 0; i < numPages; i++) {
      thumbnails.push(i + 1)
    }
    setThumbnails(thumbnails)
    setLoadedPdf(pdf)
    renderPage(pdf, pageNumber)
  }

  const onSelectDocument = file => {
    const newFile = new Blob([file.file], { type: 'application/pdf' })
    signedDocumentStore.setFileBlob(newFile)
    signedDocumentStore.setOriginFileObj(file.file)
  }

  const onSignatureCheckChanged = signature => {
    if (signature === selectedSignature) {
      handleSelectSignature(null, null)
      setSelectedSignature(null)
      setIdImg(null)
      setRectangles(null)
      return
    }
    const signId = signature.signId
    const img = document.getElementById(signId)
    handleSelectSignature(signId, img.naturalWidth / img.naturalHeight)
    setSelectedSignature(signature)
  }

  const onSignVisibleChange = values => {
    if (values.length > 0) {
      setVisibleSignature(SIGN_VISIBLE.HIDE)
    } else {
      setVisibleSignature(SIGN_VISIBLE.VISIBLE)
    }
  }

  const onAddFooterChange = values => {
    setAddFooter(values.includes('ADD_FOOTER'))
  }

  const memoizedRectangles = useMemo(() => {
    return rectangles?.map((rect, i) => (
      <RectangleBox
        key={i}
        urlImg={`${apiUrl}/api/v1/images/${idImg}`}
        shapeProps={rect}
        isSelected={true}
        scale={1} // Có thể điều chỉnh scale nếu cần
        canvasWidth={styleCanvas.width}
        canvasHeight={styleCanvas.height}
        onChange={newAttrs => {
          setRectangles(prevRects => {
            const updatedRects = [...prevRects]
            updatedRects[i] = newAttrs
            return updatedRects
          })
        }}
      />
    ))
  }, [rectangles, apiUrl, idImg, styleCanvas.width, styleCanvas.height])

  return (
    <PopupSignWrapper
      visible={isVisiblePopupSign}
      onCancel={handleFinishSign}
      width={1300}
      style={{ top: 20 }}
      title="Ký số tài liệu"
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            {!hiddenSelectDocument && (
              <Upload
                accept={'.pdf'}
                beforeUpload={() => false}
                showUploadList={false}
                onChange={onSelectDocument}>
                <Button>
                  Chọn tài liệu ký số
                </Button>
              </Upload>
            )}
          </div>
          <Space>
            {responseSign ? (
              <Button
                type={'primary'}
                onClick={handleFinishSign}
                style={{
                  backgroundColor: '#389e0d',
                }}>
                Hoàn thành
              </Button>
            ) : (
              <>
                <Button danger onClick={handleFinishSign}>
                  Hủy bỏ
                </Button>
                <Button
                  type={'primary'}
                  onClick={
                    selectedSignature &&
                    selectedSignature?.typeSignature ===
                      SIGN_TYPES.CIRCLE_SIGN
                      ? showSignModal
                      : showSignConfirm
                  }
                >
                  Đồng ý
                </Button>
              </>
            )}
          </Space>
        </div>
      }>

      <ContentBlockWrapper>
        {
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 20,
            }}>
            <div style={{ flexGrow: 1 }}>
              <DocumentWrapper fileBlob={fileBlob}>
                {fileBlob && loadedPdf && (
                  <DocumentController maxWidth={styleCanvas.width}>
                    {fileBlob && (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}>
                        <Button
                          style={{ width: 42 }}
                          onClick={() => {
                            if (pageNumber === 1) return
                            setPageNumber(pageNumber - 1)
                            renderPage(loadedPdf, pageNumber - 1)
                          }}
                          icon={<LeftOutlined />}
                        />
                        <p style={{ margin: '0 10px' }}>
                          {pageNumber}/ {numPages}
                        </p>

                        <Button
                          style={{ width: 42 }}
                          onClick={() => {
                            if (pageNumber === numPages) return
                            setPageNumber(pageNumber + 1)
                            renderPage(loadedPdf, pageNumber + 1)
                          }}
                          icon={<RightOutlined />}
                        />
                      </div>
                    )}
                  </DocumentController>
                )}
                {originFileObj && loadedPdf && !responseSign && (
                  <NameDocument maxWidth={styleCanvas.width}>
                    <Tooltip>
                      <FileTextOutlined
                        style={{ color: blue, fontSize: 16, marginRight: 10 }}
                      />
                      <span style={{ lineHeight: '20px' }}>
                        {trimOverLengthString(originFileObj.name, 70)}
                      </span>
                    </Tooltip>
                  </NameDocument>
                )}
                {responseSign &&
                  loadedPdf &&
                  responseSign.data?.listSignFile?.length > 0 && (
                    <NameDocument maxWidth={styleCanvas.width} signed={true}>
                      <Tooltip title={'Tải xuống'}>
                        <div
                          onClick={() =>
                            fileStore.handleDownloadFile(
                              responseSign.data.listSignFile[0].fileSignId,
                              responseSign.data.listSignFile[0].fileSignName
                            )
                          }>
                          <DownloadOutlined
                            style={{
                              color: '#27ae60',
                              fontSize: 16,
                              marginRight: 10,
                            }}
                          />
                          <span style={{ lineHeight: '20px' }}>
                            {trimOverLengthString(
                              responseSign.data?.listSignFile[0]?.fileSignName,
                              70
                            )}
                          </span>
                          <Tag color={'green'} style={{ marginLeft: 8 }}>
                            Đã ký
                          </Tag>
                        </div>
                      </Tooltip>
                    </NameDocument>
                  )}
                {fileBlob ? (
                  <div className={'document-wrapper'}>
                    <Document
                      style={{ display: 'flex', justifyContent: 'center' }}
                      file={fileBlob}
                      onLoadSuccess={onDocumentLoadSuccess}
                      loading={
                        <div className={'spin-box'}>
                          <Spin tip="Đang tải tài liệu" />
                        </div>
                      }>
                      <Page pageNumber={pageNumber} loading={null} />
                    </Document>
                    <Stage
                      width={styleCanvas.width}
                      height={styleCanvas.height}
                      style={{
                        position: 'absolute',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        border: styleCanvas.border,
                        top: 0,
                        zIndex: 9,
                      }}>
                      <Layer>{memoizedRectangles}</Layer>
                    </Stage>
                  </div>
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={'Vui lòng chọn tài liệu ký số!'}
                  />
                )}
              </DocumentWrapper>
            </div>

            <div style={{ width: 330, height: '75vh', padding: '0 10px', backgroundColor: '#fff', border: '1px solid #f0f0f0', borderRadius: 8, overflow: 'hidden' }}>
              <Tabs defaultActiveKey="1">
                <TabPane tab="Tùy chọn ký" key="1">
                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ fontWeight: 600, marginRight: 10 }}>
                      Loại ký:{' '}
                    </label>
                    <CheckboxGroup
                      options={options}
                      onChange={onSignVisibleChange}
                    />
                  </div>
                  {!hiddenFooterOption && (
                    <div style={{ marginBottom: '1rem' }}>
                      <label style={{ fontWeight: 600, marginRight: 10 }}>
                        Footer:{' '}
                      </label>
                      <CheckboxGroup
                        options={footerOptions}
                        value={addFooter ? ['ADD_FOOTER'] : []}
                        onChange={onAddFooterChange}
                      />
                    </div>
                  )}
                  <div style={{ position: 'relative', marginTop: 10 }}>
                    <SpinnerInlineComponent sizeSpin={'small'} />

                    <SignatureList>
                      {signatureList ? (
                        signatureList.map(signature => (
                          <SignatureBox
                            key={signature.signId}
                            onClick={() => onSignatureCheckChanged(signature)}>
                            <Card
                              hoverable
                              className={'card'}
                              cover={
                                <div className={'img-box'}>
                                  <img
                                    alt="signature"
                                    src={`${apiUrl}/api/v1/images/${signature.signId}`}
                                    id={signature.signId}
                                  />
                                </div>
                              }>
                              <Meta
                                title={
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                    }}>
                                    <span>{signature.signName}</span>
                                    <Checkbox
                                      checked={selectedSignature === signature}
                                    />
                                  </div>
                                }></Meta>
                            </Card>
                          </SignatureBox>
                        ))
                      ) : (
                        <EmptyContent
                          description={
                            'Bạn chưa có chữ ký nào, hãy tạo chữ ký!'
                          }
                        />
                      )}
                    </SignatureList>
                  </div>
                </TabPane>
                <TabPane tab="Phụ lục tài liệu" key="2">
                  <ThumbnailsWrapper>
                    <Document
                      noData={
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description={'Hãy chọn tài liệu!'}
                        />
                      }
                      file={fileBlob}
                      loading={
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: 170,
                          }}>
                          <Spin />
                        </div>
                      }>
                      {thumbnails.map(thumbnailNumber => {
                        return (
                          <div
                            className={
                              thumbnailNumber === pageNumber
                                ? 'thumbnail-box thumbnail-box-active'
                                : 'thumbnail-box'
                            }
                            onClick={() => setPageNumber(thumbnailNumber)}
                            key={thumbnailNumber}>
                            <Page
                              pageNumber={thumbnailNumber}
                              loading={null}
                              width={125}
                            />
                            <div style={{ fontWeight: 'bold' }}>
                              {thumbnailNumber}
                            </div>
                          </div>
                        )
                      })}
                    </Document>
                  </ThumbnailsWrapper>
                </TabPane>
              </Tabs>
            </div>
          </div>
        }
      </ContentBlockWrapper>
      <SignModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        displaySignChecked={displaySignChecked}
        setDisplaySignChecked={setDisplaySignChecked}
        otherCheckboxValues={otherCheckboxValues}
        setOtherCheckboxValues={setOtherCheckboxValues}
        handleSign={handleSign}
        combinedValues={combinedValues}
      />
    </PopupSignWrapper>
  )
}

PopupSign.propTypes = {}

export default memo(
  inject(
    'signedDocumentStore',
    'loadingAnimationStore',
    'authenticationStore',
    'fileStore'
  )(observer(PopupSign))
)
